"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dnpColumnClassificationSchema = exports.dnpColumnShortlistEntrySchema = void 0;
const zod_1 = require("zod");
const dnp_classification_gate_1 = require("./dnp-classification-gate");
const dnp_column_candidate_finder_1 = require("./dnp-column-candidate-finder");
const dnp_column_decision_1 = require("./dnp-column-decision");
exports.dnpColumnShortlistEntrySchema = zod_1.z.object({
    rule: dnp_column_decision_1.dnpColumnRuleSchema,
    confidence: zod_1.z.number().min(0).max(1),
    reason: zod_1.z.string(),
    states: zod_1.z.array(dnp_column_candidate_finder_1.dnpColumnStateSchema),
    absentCount: zod_1.z.number().int().nonnegative(),
    markerCount: zod_1.z.number().int().nonnegative().nullable(),
});
exports.dnpColumnClassificationSchema = zod_1.z.object({
    outcome: zod_1.z.nativeEnum(dnp_classification_gate_1.DnpClassificationOutcome),
    shortlist: zod_1.z.array(exports.dnpColumnShortlistEntrySchema),
    columnNames: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=dnp-column-shortlist.js.map